import { IInventoryPage } from './inventory-page.interface';
import { GENERAL_DASHBOARD_PAGE } from './inventory/general/dashboard';
import { GENERAL_NOT_FOUND_PAGE } from './inventory/general/not-found';
import { RESEARCH_ADVERTISEMENT_AD_LISTS_PAGE } from './inventory/research/advertisement/ad-lists';
import { RESEARCH_ADVERTISEMENT_AD_SUGGESTIONS_PAGE } from './inventory/research/advertisement/ad-suggestions';
import { RESEARCH_ADVERTISEMENT_POSITIONING_PAGE } from './inventory/research/advertisement/positioning';
import { RESEARCH_AI_AI_DESIGN_EDITOR_PAGE } from './inventory/research/ai/ai-design-editor';
import { RESEARCH_AI_NICHE_FINDER_PAGE } from './inventory/research/ai/niche-finder';
import { RESEARCH_AI_PROMPT_SEARCH_PAGE } from './inventory/research/ai/prompt-search';
import { RESEARCH_AI_QUOTES_AND_PUNS_PAGE } from './inventory/research/ai/quotes-and-puns';
import { RESEARCH_EVENTS_EVENT_CALENDAR_PAGE } from './inventory/research/events/event-calendar';
import { RESEARCH_EVENTS_SOCIAL_MEDIA_HOLIDAYS_PAGE } from './inventory/research/events/social-media-holidays';
import { RESEARCH_KEYWORD_KW_COMPETITION_PAGE } from './inventory/research/keyword/kw-competition';
import { RESEARCH_KEYWORD_KW_HUNTER_PAGE } from './inventory/research/keyword/kw-hunter';
import { RESEARCH_KEYWORD_KW_LISTS_PAGE } from './inventory/research/keyword/kw-lists';
import { RESEARCH_KEYWORD_KW_SEARCH_PAGE } from './inventory/research/keyword/kw-search';
import { RESEARCH_KEYWORD_KW_SUGGESTIONS_PAGE } from './inventory/research/keyword/kw-suggestions';
import { RESEARCH_KEYWORD_KW_WORKBENCH_PAGE } from './inventory/research/keyword/kw-workbench';
import { RESEARCH_KEYWORD_PRODUCT_EXPLORER_PAGE } from './inventory/research/keyword/product-explorer';
import { RESEARCH_KEYWORD_TAG_GENERATOR_PAGE } from './inventory/research/keyword/tag-generator';
import { RESEARCH_RESEARCH_ARCHIVE_PAGE } from './inventory/research/research/archive';
import { RESEARCH_RESEARCH_BEST_SELLERS_PAGE } from './inventory/research/research/best-sellers';
import { RESEARCH_RESEARCH_BRANDS_PAGE } from './inventory/research/research/brands';
import { RESEARCH_RESEARCH_DELETED_DESIGNS_PAGE } from './inventory/research/research/deleted-designs';
import { RESEARCH_RESEARCH_DETAIL_BY_TYPE_BY_ASIN_PAGE } from './inventory/research/research/detail/by-type/by-asin';
import { RESEARCH_RESEARCH_FAVORITES_PAGE } from './inventory/research/research/favorites';
import { RESEARCH_RESEARCH_GET_INSPIRED_POD_PAGE } from './inventory/research/research/get-inspired-pod';
import { RESEARCH_RESEARCH_HOBBY_LIST_PAGE } from './inventory/research/research/hobby-list';
import { RESEARCH_RESEARCH_NICHE_ANALYSIS_PAGE } from './inventory/research/research/niche-analysis';
import { RESEARCH_RESEARCH_POD_REPORT_PAGE } from './inventory/research/research/pod-report';
import { RESEARCH_RESEARCH_REAL_TIME_RESEARCH_PAGE } from './inventory/research/research/real-time-research';
import { RESEARCH_RESEARCH_SELLER_TRENDS_PAGE } from './inventory/research/research/seller-trends';
import { RESEARCH_TRADEMARK_TM_REGISTRATIONS_PAGE } from './inventory/research/trademark/tm-registrations';
import { RESEARCH_TRADEMARK_TM_SEARCH_PAGE } from './inventory/research/trademark/tm-search';
import { RESEARCH_TRADEMARK_TM_WATCHLIST_PAGE } from './inventory/research/trademark/tm-watchlist';
import { SETTINGS_ACCOUNT_PAGE } from './inventory/settings/account';
import { SETTINGS_APPEARANCE_PAGE } from './inventory/settings/appearance';
import { SETTINGS_PASSWORD_PAGE } from './inventory/settings/password';
import { SETTINGS_RESEARCH_EMAIL_NOTIFICATIONS_PAGE } from './inventory/settings/research/email-notifications';
import { SETTINGS_SUBSCRIPTIONS_PAGE } from './inventory/settings/subscriptions';
import { SETTINGS_TOKENS_PAGE } from './inventory/settings/tokens';
import { STORE_KEYWORD_PAGE } from './inventory/store/keyword';
import { STORE_RESEARCH_PAGE } from './inventory/store/research';
import { STORE_UPLOAD_PAGE } from './inventory/store/upload';
import { SUPPORT_PAGE } from './inventory/support';
import { SUPPORT_REPORT_PAGE } from './inventory/support/report';
import { TUTORIALS_PAGE } from './inventory/tutorials';
import { TUTORIALS_BY_TUTORIALURL_PAGE } from './inventory/tutorials/by-tutorialUrl';
import { GENERAL_UI_FOUNDATION_PREVIEW_PAGE } from './inventory/general/ui-foundation-preview';
import { UPLOAD_EDIT_PAGE } from './inventory/upload/edit';
import { UPLOAD_KDP_EDIT_PAGE } from './inventory/upload/kdp/edit';
import { UPLOAD_POD_AI_DESIGN_EDITOR_PAGE } from './inventory/upload/pod/ai-design-editor';
import { UPLOAD_POD_AI_TEMPLATES_PAGE } from './inventory/upload/pod/ai-templates';
import { UPLOAD_POD_DESIGN_MANAGEMENT_PAGE } from './inventory/upload/pod/design-management';
import { UPLOAD_POD_EDIT_PAGE } from './inventory/upload/pod/edit';
import { UPLOAD_POD_EDIT_BY_MODE_PAGE } from './inventory/upload/pod/edit/by-mode';
import { UPLOAD_POD_STATISTICS_PAGE } from './inventory/upload/pod/statistics';
import { UPLOAD_POD_TM_BLACKLIST_PAGE } from './inventory/upload/pod/tm-blacklist';
import { UPLOAD_POD_TM_REPORT_PAGE } from './inventory/upload/pod/tm-report';
import { UPLOAD_POD_TM_WHITELIST_PAGE } from './inventory/upload/pod/tm-whitelist';
import { UPLOAD_UPLOAD_ACCOUNTS_TEMPLATES_PAGE } from './inventory/upload/upload/accounts-templates';
import { UPLOAD_UPLOAD_SETUP_KDP_UPLOADER_PAGE } from './inventory/upload/upload/setup-kdp-uploader';
import { UPLOAD_UPLOAD_SETUP_POD_UPLOADER_PAGE } from './inventory/upload/upload/setup-pod-uploader';
import { UPLOAD_UPLOAD_TEMPLATE_GROUPS_PAGE } from './inventory/upload/upload/template-groups';
import { USER_EMAIL_VERIFY_PAGE } from './inventory/user/email-verify';
import { USER_FORGOT_PASSWORD_PAGE } from './inventory/user/forgot-password';
import { USER_LOGIN_PAGE } from './inventory/user/login';
import { USER_SIGN_UP_PAGE } from './inventory/user/sign-up';
import { USER_VERIFY_SUCCESS_PAGE } from './inventory/user/verify-success';

// Keep catalog order stable: lookup ranking uses it to break equal relevance scores.
export const APPLICATION_INVENTORY: IInventoryPage[] = [
	GENERAL_DASHBOARD_PAGE,
	GENERAL_NOT_FOUND_PAGE,
	RESEARCH_ADVERTISEMENT_AD_LISTS_PAGE,
	RESEARCH_ADVERTISEMENT_AD_SUGGESTIONS_PAGE,
	RESEARCH_ADVERTISEMENT_POSITIONING_PAGE,
	RESEARCH_AI_AI_DESIGN_EDITOR_PAGE,
	RESEARCH_AI_NICHE_FINDER_PAGE,
	RESEARCH_AI_PROMPT_SEARCH_PAGE,
	RESEARCH_AI_QUOTES_AND_PUNS_PAGE,
	RESEARCH_EVENTS_EVENT_CALENDAR_PAGE,
	RESEARCH_EVENTS_SOCIAL_MEDIA_HOLIDAYS_PAGE,
	RESEARCH_KEYWORD_KW_COMPETITION_PAGE,
	RESEARCH_KEYWORD_KW_HUNTER_PAGE,
	RESEARCH_KEYWORD_KW_LISTS_PAGE,
	RESEARCH_KEYWORD_KW_SEARCH_PAGE,
	RESEARCH_KEYWORD_KW_SUGGESTIONS_PAGE,
	RESEARCH_KEYWORD_KW_WORKBENCH_PAGE,
	RESEARCH_KEYWORD_PRODUCT_EXPLORER_PAGE,
	RESEARCH_KEYWORD_TAG_GENERATOR_PAGE,
	RESEARCH_RESEARCH_ARCHIVE_PAGE,
	RESEARCH_RESEARCH_BEST_SELLERS_PAGE,
	RESEARCH_RESEARCH_BRANDS_PAGE,
	RESEARCH_RESEARCH_DELETED_DESIGNS_PAGE,
	RESEARCH_RESEARCH_DETAIL_BY_TYPE_BY_ASIN_PAGE,
	RESEARCH_RESEARCH_FAVORITES_PAGE,
	RESEARCH_RESEARCH_GET_INSPIRED_POD_PAGE,
	RESEARCH_RESEARCH_HOBBY_LIST_PAGE,
	RESEARCH_RESEARCH_NICHE_ANALYSIS_PAGE,
	RESEARCH_RESEARCH_POD_REPORT_PAGE,
	RESEARCH_RESEARCH_REAL_TIME_RESEARCH_PAGE,
	RESEARCH_RESEARCH_SELLER_TRENDS_PAGE,
	RESEARCH_TRADEMARK_TM_REGISTRATIONS_PAGE,
	RESEARCH_TRADEMARK_TM_SEARCH_PAGE,
	RESEARCH_TRADEMARK_TM_WATCHLIST_PAGE,
	SETTINGS_ACCOUNT_PAGE,
	SETTINGS_APPEARANCE_PAGE,
	SETTINGS_PASSWORD_PAGE,
	SETTINGS_RESEARCH_EMAIL_NOTIFICATIONS_PAGE,
	SETTINGS_SUBSCRIPTIONS_PAGE,
	SETTINGS_TOKENS_PAGE,
	STORE_KEYWORD_PAGE,
	STORE_RESEARCH_PAGE,
	STORE_UPLOAD_PAGE,
	SUPPORT_PAGE,
	SUPPORT_REPORT_PAGE,
	TUTORIALS_PAGE,
	TUTORIALS_BY_TUTORIALURL_PAGE,
	GENERAL_UI_FOUNDATION_PREVIEW_PAGE,
	UPLOAD_EDIT_PAGE,
	UPLOAD_KDP_EDIT_PAGE,
	UPLOAD_POD_AI_DESIGN_EDITOR_PAGE,
	UPLOAD_POD_AI_TEMPLATES_PAGE,
	UPLOAD_POD_DESIGN_MANAGEMENT_PAGE,
	UPLOAD_POD_EDIT_PAGE,
	UPLOAD_POD_EDIT_BY_MODE_PAGE,
	UPLOAD_POD_STATISTICS_PAGE,
	UPLOAD_POD_TM_BLACKLIST_PAGE,
	UPLOAD_POD_TM_REPORT_PAGE,
	UPLOAD_POD_TM_WHITELIST_PAGE,
	UPLOAD_UPLOAD_ACCOUNTS_TEMPLATES_PAGE,
	UPLOAD_UPLOAD_SETUP_KDP_UPLOADER_PAGE,
	UPLOAD_UPLOAD_SETUP_POD_UPLOADER_PAGE,
	UPLOAD_UPLOAD_TEMPLATE_GROUPS_PAGE,
	USER_EMAIL_VERIFY_PAGE,
	USER_FORGOT_PASSWORD_PAGE,
	USER_LOGIN_PAGE,
	USER_SIGN_UP_PAGE,
	USER_VERIFY_SUCCESS_PAGE
];
